<template>
  <b-overlay
  :show="loading"
  rounded="lg">
    <b-card title="Delivery Process">
      <b-col cols="4">
        <b-button variant="primary" :to="{ name: 'ongoing-delivery' }" size="sm">
          <feather-icon size="1x" icon="ArrowLeftIcon" /> Back to Ongoing Delivery
        </b-button>
      </b-col>
      <br />
      <b-col cols="12">
        <b-row>
          <b-col cols="12" style="margin-top:10px">
            <div class="mb-2">
              <b-row>
                <b-col cols="4"><strong>SO Number</strong></b-col>
                <b-col>: {{ formatJoin(delivery.listOrderNumber) }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><strong>Status</strong></b-col>
                <b-col>: {{ delivery.status }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><strong>Created At</strong></b-col>
                <b-col>: {{ new Date(delivery.createdAt).toLocaleString() }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><strong>Timer</strong></b-col>
                <b-col>: {{ totalTimer }}</b-col>
              </b-row>
            </div>
            <br>
            <b-table
              :items="deliveryItem"
              :fields="fieldPicklist"
              responsive="xl"
              hover
              head-variant="dark"
              outlined
              small
              class="table-responsive"
              sticky-header
            >
            </b-table>
            <div class="d-flex flex-column w-100 mt-1">
              <b-button
                variant="success"
                class="mb-2"
                @click="startDelivery"
                :disabled="delivery.status !== 'Created'"
              >
                Start
              </b-button>
              <b-button
                variant="warning"
                @click="endDelivery"
                :disabled="delivery.status !== 'In Progress'"
              >
                End
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <br />
    </b-card>
  </b-overlay>
</template>
  
<script>
  export default {
    props: ["id"],
    data() {
      return {
        fieldPicklist: [
          { key: "pickList.picklistNo", label: "Pick List Number" },
          { key: "pickList.picklistLine", label: "Line Item" },
          { key: "pickList.lineDescription", label: "Line Description" },
          { key: "pickList.fromBatch", label: "Drum Number" },
          { key: "pickList.pickListType", label: "Pick List Type" },
          { key: "pickList.quantity", label: "Quantity" },
          { key: "pickList.unit", label: "Unit" },
          { key: "pickList.binLocation", label: "Bin Location" },
          { key: "pickList.props.statusNo", label: "Status" },
          { key: "pickList.cableLengthInfo", label: "Cable Length" },
          { key: "pickList.cableWeight", label: "Cable Weight" },
          { key: "pickList.deliveryAddressOne", label: "Address 1" },
          { key: "pickList.deliveryAddressTwo", label: "Address 2" }
        ],
        delivery: {
          listOrderNumber: [],
          status: '',
          deliveryNumber: '',
          createdAt: new Date()
        },
        deliveryItem: [],
        loading: false,
        header: [
          {
            orderNumber: '',
            createdAt: '',
            deliveryAddressOne: '',
            deliveryAddressTwo: ''
          }
        ],
        disableButtonSelectPicklist: false,
        totalTimer: '00:00:00',
        startTimer: null,
        endTimer: null
      };
    },

    methods: {
      formatJoin(data) {
        if (!Array.isArray(data) || data.length === 0) {
          return ''
        }
        // Remove empty strings and undefined, then deduplicate
        const filtered = Array.from(new Set(data.filter(x => x !== '' && x !== undefined && x !== ' ')))
        return filtered.join(', ')
      },
      async timerRunStart() {
          // Pastikan this.startTimer sudah disetel.
          // Jika belum, inisialisasi dengan waktu sekarang.
          if (!this.startTimer) {
              this.startTimer = new Date().getTime();
          }

          const startTime = new Date(this.startTimer).getTime();
          console.log("🚀 ~ startTime:", startTime)
          const currentTime = new Date().getTime();
          console.log("🚀 ~ currentTime:", currentTime)
          
          let elapsedTime = (currentTime) - startTime;
          console.log("🚀 ~ elapsedTime:", elapsedTime)

          // Jika waktu yang berlalu negatif (waktu mulai di masa depan),
          // setel kembali ke 0 dan perbarui waktu mulai.
          if (elapsedTime < 0) {
              elapsedTime = 0;
              this.startTimer = currentTime; // Atur ulang startTimer untuk perhitungan berikutnya
          }
          console.log("🚀123 ~ elapsedTime:", elapsedTime)

          const hours = Math.floor(elapsedTime / (1000 * 60 * 60));
          const minutes = Math.floor((elapsedTime % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((elapsedTime % (1000 * 60)) / 1000);

          this.totalTimer = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

          // Lanjutkan timer jika masih berjalan
          if (!this.endTimer) {
              setTimeout(() => {
                  this.timerRunStart();
              }, 1000);
          }
      },
      async startDelivery() {
        this.loading = true;
        await this.$store.dispatch("delivery/processDelivery", {
          id: this.id,
          action: "start"
        })
        .then((res) => {
          this.fetchData();
        }).catch((err) => {
          console.error(err);
        }).finally(() => {
          this.loading = false;
        })
      },
      async endDelivery() {
        this.loading = true;
        await this.$store.dispatch("delivery/processDelivery", {
          id: this.id,
          action: "end"
        })
        .then((res) => {
          this.fetchData();
          this.$router.push({ name: 'ongoing-delivery' });
        }).catch((err) => {
          console.error(err);
        }).finally(() => {
          this.loading = false;
        })
      },
      async fetchData(){
        this.loading = true;
        await this.$store.dispatch("delivery/getDeliveryById", this.id)
        .then((res) => {
          this.endTimer = res.end;
          this.startTimer = res.start;
          this.delivery.listOrderNumber = res.listOrderNumber;
          this.delivery.status = res.status;
          this.delivery.deliveryNumber = res.deliveryNumber;
          this.delivery.createdAt = res.createdAt;
          if (res.item) {
            this.deliveryItem = res.item;
          }
          if (res.start && !res.end) {
            this.timerRunStart(new Date(res.start).getTime(), new Date().getTime())
          }
        }).catch((err) => {
          console.error(err);
        }).finally(() => {
          this.loading = false;
        })
      }
    },
    created() {
      document.title = "Delivery Picking Process | Tai Sin";
    },
    computed: {
    },
    watch: {
    },
    mounted() {
      this.fetchData();
    },
  };
</script>

<style scoped>
.scrollable-table {
  overflow-x: auto;
  width: 100%;
}
</style>